module.exports = __webpack_public_path__ + "img/sun_half.9dacefa7.svg";